if (!customElements.get('compare-2col-list-v2')) {
    customElements.define(
        'compare-2col-list-v2',
        class CompareColListV extends HTMLElement {
            constructor() {
                super();
                this.mainButton = this.querySelector('.compare-2col-list-v2-item-buy-button');
                this.colItem = this.querySelectorAll('.compare-2col-list-v2-item');
                this.resizeObserver = null;
            }

            connectedCallback() {
                if (this.mainButton) {
                    const productInfoElement = document.querySelector('.product-information');
                    if (productInfoElement) {
                        this.mainButton.addEventListener('click', () => {
                            productInfoElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            productInfoElement.setAttribute('tabindex', '-1');
                        });
                    }
                }

                // 默认处理内容区域
                this.sameHeight('.compare-2col-list-v2-item-content', 'li');

                // 如果需要也可以处理颜色区域
                // this.sameHeight('.compare-2col-list-v2-item-colors');

                this.setupResizeObserver();
            }

            /**
             * 通用等高处理方法
             * @param {string} targetSelector - 目标容器的选择器
             * @param {string} [childSelector] - 子元素选择器(可选，默认为所有直接子元素)
             */
            sameHeight(targetSelector, childSelector) {
                if (this.colItem.length < 2) return;

                // 1. 获取所有目标元素
                const targetEls = Array.from(this.colItem).map(item =>
                    item.querySelector(targetSelector)
                ).filter(Boolean);

                if (targetEls.length < 2) return;

                // 2. 获取所有子元素并按索引分组
                const childGroups = {};

                targetEls.forEach((targetEl, colIndex) => {
                    // 处理子元素选择器
                    let children;
                    if (!childSelector) {
                        // 如果没有指定子元素选择器，获取所有直接子元素
                        children = Array.from(targetEl.children);
                    } else {
                        // 如果指定了子元素选择器，使用querySelectorAll
                        children = Array.from(targetEl.querySelectorAll(childSelector));
                    }

                    children.forEach((child, index) => {
                        if (!childGroups[index]) {
                            childGroups[index] = [];
                        }
                        childGroups[index].push(child);
                    });
                });

                // 3. 为每组子元素设置相同高度
                Object.values(childGroups).forEach(group => {
                    // 先重置高度
                    group.forEach(child => {
                        child.style.height = '';
                        child.style.minHeight = '';
                    });

                    // 找出组内最大高度
                    const maxHeight = Math.max(
                        ...group.map(child => child.offsetHeight)
                    );

                    // 设置所有子元素为最大高度
                    group.forEach(child => {
                        child.style.minHeight = `${maxHeight}px`;
                    });
                });
            }

            setupResizeObserver() {
                if (typeof ResizeObserver !== 'undefined') {
                    this.resizeObserver = new ResizeObserver(() => {
                        // 重新计算所有可能需要等高的区域
                        this.sameHeight('.compare-2col-list-v2-item-content');
                        // this.sameHeight('.compare-2col-list-v2-item-colors');
                    });

                    // 监听所有列项的变化
                    this.colItem.forEach(item => {
                        this.resizeObserver.observe(item);
                    });
                } else {
                    window.addEventListener('resize', () => {
                        this.sameHeight('.compare-2col-list-v2-item-content');
                        // this.sameHeight('.compare-2col-list-v2-item-colors');
                    });
                }
            }

            disconnectedCallback() {
                if (this.resizeObserver) {
                    this.resizeObserver.disconnect();
                }
                window.removeEventListener('resize', this.sameHeight);
            }
        }
    );
}